/*
Usage example in asset:
<div
    class="js-timer"
    data-count-down-timer="2027-01-30T23:59:59.475">
    <div class="count-down">
        <span
            class="js-timer-days"
            data-counter-msg="[days] days [hours] hr [minutes] min [seconds] sec left!">
        </span>
        <span
            class="js-timer-oneday"
            data-counter-msg="[days] day [hours] hr [minutes] min [seconds] sec left!">
        </span>
        <span
            class="js-timer-nodays"
            data-counter-msg="[hours] hr [minutes] min [seconds] sec left!">
        </span>
    </div>
</div>

use modifiers to add bg/text colors:
pink, cyan, aero, night
*/

'use strict';

const { queryFirst, queryAll, addClass, hasClass } = require('../domUtil');
const { HIDDEN_CLASS, ACTIVE_CLASS } = require('../constants');
const { getTimeRemaining, tokenize } = require('../util');

function renderTick(msgDays, countDownTime, timerEl, msgNoDays, msgOneDay) {
    const t = getTimeRemaining(countDownTime);
    const template = (t.days === 0) ? msgNoDays : (t.days === 1 ? msgOneDay : msgDays);

    if (timerEl) {
        timerEl.innerHTML = tokenize(template, t, '[', ']');
    }
    return t.total <= 0;
}

/**
 * Initialize all timers found under the given root.
 */
function initTimers(root = document) {
    const timers = queryAll('.js-timer', root);

    if (!timers || !timers.length) return;

    for (let i = 0; i < timers.length; i++) {
        const timerEl = timers[i];
        if(!hasClass(ACTIVE_CLASS, timerEl)) {
            const { countDownTimer: countDownTime } = timerEl.dataset || {};

            const timerDays   = queryFirst('.js-timer-days',   timerEl);
            const timerNoDays = queryFirst('.js-timer-nodays', timerEl);
            const timerOneDay = queryFirst('.js-timer-oneday', timerEl);

            // Guard: required sub-nodes may be missing
            if (!timerDays || !timerNoDays || !timerOneDay) continue;

            const { counterMsg: msgDays } = timerDays.dataset;
            const { counterMsg: msgNoDays } = timerNoDays.dataset;
            const { counterMsg: msgOneDay } = timerOneDay.dataset;

            if (!countDownTime) {
                addClass(timerDays, HIDDEN_CLASS);
                continue;
            }

            // Initial tick
            let done = renderTick(msgDays, countDownTime, timerDays, msgNoDays, msgOneDay);

            if (!done) {
                const handle = setInterval(() => {
                    done = renderTick(msgDays, countDownTime, timerDays, msgNoDays, msgOneDay);
                    if (done) clearInterval(handle);
                }, 1000);
            }
            // Mark the ones that activated:
            addClass(timerEl, ACTIVE_CLASS);
        }
    }
}

function init() {
    // Init on page load
    initTimers();

    document.addEventListener('slot-loaded', (e) => {
        const { target } = e;
        const hasTimers = queryAll('.js-timer', target);

        if (hasTimers?.length) {
            initTimers(target);
        }
    });
}

export default init;
